module.exports = __webpack_public_path__ + "img/market.a284dd37.svg";